import logo from "./logo.svg";
import "./App.css";
import Calculator from "./buildCalculator/Calculator";

const App = () => {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
};

export default App;
